import React from "react";
import { ArrowLeftOutlined, DownloadOutlined, SearchOutlined } from "@ant-design/icons";
import EnrollStats from "./EnrollStats";
import IncentiveSlabs from "./IncentiveSlabs";
import SalarySheetTable from "./SalarySheetTable";
import useSalarySheet from "./useSalarySheet";
import { fmtDateWithWeekday } from "../Insights/format";
import { dateInIndia } from "./dates";
import { Empty, riderCount } from "./settlementParts";

export default function SalaryEnrollment({ initialDate, onBack }) {
  const { date, setDate, sheet, rows, visible, slabs, setSlabs, search, setSearch, busy, submitting, entryOf, change, load, submit, download } =
    useSalarySheet(initialDate);
  const hasRows = rows.length > 0;

  return (
    <div className="container-fluid stl">
      <section className="stl-card stl-toolbar">
        <div className="stl-toolbar__group">
          <button type="button" className="stl-btn stl-btn--secondary" onClick={onBack}>
            <ArrowLeftOutlined /> Submitted salaries
          </button>
          <label className="stl-field">
            <span className="stl-field__label">Day</span>
            <input className="stl-input" type="date" value={date} max={dateInIndia()} onChange={(e) => setDate(e.target.value)} />
          </label>
          <button type="button" className="stl-btn stl-btn--primary" disabled={busy !== ""} onClick={load}>
            {busy === "load" ? "Loading…" : "Load the day"}
          </button>
        </div>
      </section>

      {hasRows && <EnrollStats sheet={sheet} rows={rows} />}

      <IncentiveSlabs slabs={slabs} onChange={setSlabs} />

      <section className="stl-card stl-table-card">
        <div className="stl-table-bar">
          <div className="stl-table-bar__title">
            <h2 className="stl-title">Enroll salaries</h2>
            {sheet && (
              <span className="stl-subtitle">
                {fmtDateWithWeekday(sheet.date)}
                {hasRows && (search.trim() ? ` · ${visible.length} of ${riderCount(rows.length)}` : ` · ${riderCount(rows.length)}`)}
              </span>
            )}
          </div>
          {hasRows && (
            <div className="stl-table-bar__tools">
              <div className="stl-search">
                <SearchOutlined />
                <input className="stl-input" placeholder="Search rider or ID" aria-label="Search rider or ID" value={search} onChange={(e) => setSearch(e.target.value)} />
              </div>
              <button type="button" className="stl-btn stl-btn--secondary" onClick={download}>
                <DownloadOutlined /> Download CSV
              </button>
            </div>
          )}
        </div>

        {!sheet ? (
          <Empty title={busy === "load" ? "Loading the day…" : "Pick a day and load it"} text="Every rider with completed orders that day shows here, ready to settle." />
        ) : !hasRows ? (
          <Empty title={`No completed orders on ${fmtDateWithWeekday(sheet.date)}`} text="Pick another day and load it." />
        ) : (
          <SalarySheetTable riders={visible} search={search} entryOf={entryOf} change={change} submitting={submitting} submit={submit} />
        )}

        <p className="stl-footnote">
          Salary = delivery charges + surge + tips + incentive + special − correction. Submit sends it to the rider's app and books the surge and
          incentive into their wallet. Cash in hand and charges owed are running balances.
        </p>
      </section>
    </div>
  );
}
